/**
 * @format
 * 
 */
import AsyncStorage from './AsyncStorage';
export default AsyncStorage;
export { useAsyncStorage } from './hooks';
//# sourceMappingURL=index.js.map